/*
Images need to be in public folder
*/
export const Education = [
    {
        When: "Jul 2014 - Jul 2019",
        Name: "Indian Institute of Technology, Kharagpur",
        URL: "http://www.iitkgp.ac.in/",
        Degree: "B.Tech & M.Tech in Computer Science & Engineering",
        Description: [
            "Awarded Honorable Mention for contributions in Technology at Annual Gymkhana awards.",
            "Served as Maintainer for MetaKGP during my final & pre-final year: a loose collaborative association of engineers & hackers",
        ],
        Logo: "/images/iitkgp.png",
    },
];

export default Education;